import '@tamagui/core/reset.css'

import { ListItem } from 'tamagui'
import { useNavigate } from 'react-router-dom'
import { getMyOrganizations, MyOrganizationsData, OrganizationData } from '../remote/organizations'
import { useEffect, useState } from 'react'
import { Button, CircularProgress, Stack, Typography } from '@mui/material'
import { Add, Business, ChevronRight } from '@mui/icons-material'

export const MyOrganizations = () => {
	const navigate = useNavigate()

	const [myOrgs, setMyOrgs] = useState<MyOrganizationsData | null>(null);
	const [isLoaded, setIsLoaded] = useState(false)
	useEffect(() => {
		getMyOrganizations((data, resp) => {
			if (data) {
				setMyOrgs(data);
				setIsLoaded(true);
			} else {
				setMyOrgs(null);
				setIsLoaded(false);
			}
		});
	}, [setMyOrgs, setIsLoaded]);

	return (
	  <>
		<Stack direction={'column'}>
			<Stack direction={'row'}>
				<Typography variant="h3">My organizations</Typography>
				<Button sx={{ml: 'auto'}} variant="contained" onClick={() => navigate('/manage/org/create')} endIcon={<Add/>}>Create organization</Button>
			</Stack>
			<br />
		  {
			isLoaded && myOrgs
			? <>
				{myOrgs && myOrgs.orgs.length > 0 ? myOrgs.orgs.map((org: OrganizationData) => {
					return (
						<ListItem onPress={() => navigate(`/manage/org/${org.id}`)} icon={Business} title={org.name} subTitle={org.email} iconAfter={ChevronRight} hoverTheme pressTheme/>
					)
				}) : <Typography variant="body1">You are not part of any organizations!</Typography>}
			</>
			: <>
				<CircularProgress />
			</>
		  }
		</Stack>
	  </>
	)
}
